import React from "react";
import Body from "./Body";

const ReliefAndWelfare = () => {
    const reliefAndWelfareColumn = [
    {
      header: "Relief",
      accessor: "relief",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div>
            <h4>{row.title}</h4>
            <span style={{ color: "var(--tableColor)" }}>#</span>
            <span>{row.donationId}</span>
          </div>
        </div>
      ),
    },
    {
      header: "Time & date",
      accessor: "dateTime",
      render: (value) => (
        <span style={{ color: "black", fontSize: "0.8rem" }}>{value}</span>
      ),
    },
    {
      header: "Eqvt. amount (INR)",
      accessor: "amount",
      render: (value) => <span className="green-text">₹ {value}</span>,
    },
  ];

  const reliefAndWelfareData = [
    {
      title: "SC/ST education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "SC/ST education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "SC/ST education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "SC/ST education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      title: "SC/ST education",
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
  ];
  const _this = { reliefAndWelfareColumn, reliefAndWelfareData };
  return <Body {..._this} />;
};

export default ReliefAndWelfare;
